import { render, staticRenderFns } from "./CardContentInvestmentFunds.vue?vue&type=template&id=895c2afa&scoped=true&"
import script from "./CardContentInvestmentFunds.vue?vue&type=script&lang=js&"
export * from "./CardContentInvestmentFunds.vue?vue&type=script&lang=js&"
import style0 from "./CardContentInvestmentFunds.vue?vue&type=style&index=0&id=895c2afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895c2afa",
  null
  
)

export default component.exports